import { GET_LOG_ERROR, GET_LOG_REQUEST, GET_LOG_SUCCESS } from "./types";
import { BASEURL } from "../../constant/config.js";

const axios = require("axios");
//API for get all logs

export const getLog = (token, data) => dispatch => {
  dispatch({ type: GET_LOG_REQUEST });
  //API for get all logs
  return axios({
    method: "POST",
    url: `${BASEURL}getAll/log`,
    headers: {
      Accept: "application/json",
      'Authorization': 'Bearer ' + token
    },
    data
  })
    .then(response => {
      return dispatch({ type: GET_LOG_SUCCESS, payload: response.data });
    })
    .catch((error) => {
      return dispatch({
        type: GET_LOG_ERROR,
        payload: [],
      });
    });
};
